import React, { useEffect } from "react";
import { useGetApplicationQuery, usePostUpsertApplicationMutation } from "@/store/service";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ApplicationStep } from "@/enum/ApplicationStep";
import { isDebugForms, getDebugNextStepUrl } from "@/util/debug";
import { bankingDetailsSchema, BankingDetailsFormData } from "@/model/schemas";
import { zodFormResolver } from "@/util/form";
import BankingDetailsForm from "./BankingDetails";

const BankingDetailsWrapper = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data: application } = useGetApplicationQuery(params.id!);
  const [postApplication, postApplicationResult] = usePostUpsertApplicationMutation();

  const form = useForm<BankingDetailsFormData>({
    resolver: zodFormResolver<BankingDetailsFormData>(bankingDetailsSchema),
    mode: "onTouched",
    defaultValues: {
      bankName: "",
    },
  });
  const { handleSubmit, getValues } = form;

  useEffect(() => {
    if (postApplicationResult.isSuccess) {
      navigate(`/application/${postApplicationResult.data.id}/${postApplicationResult.data.step}`);
    }
  }, [postApplicationResult.isSuccess]);

  const onSubmit = async (data: BankingDetailsFormData) => {
    await postApplication({ id: params.id!, step: ApplicationStep.ApplicantBankingDetails, bankingDetails: data });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate(getDebugNextStepUrl(params.id!, ApplicationStep.ApplicantBankingDetails));
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className="relative">
      <div className="w-full max-w-2xl mx-auto space-y-5">
        <h3 className="text-2xl font-semibold text-gray-900 text-center">Banking Details</h3>
        <BankingDetailsForm form={form} />
        <div className="flex justify-center pt-2">
          <button
            type="submit"
            name="submit"
            className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default BankingDetailsWrapper;
